export enum CheckoutStep {
  OptionsList = 'paymentMethod',
  OptionView = 'paymentDetails',
}
